var url = window.location.href;
if (url.includes("?cjevent")) {
    setCookie("waterdrop_ch","CJ");
    delCookie("ref", true);
}
if (url.includes("?ref")) {
    setCookie("waterdrop_ch","GoAffPro");
}
if (url.includes("?sscid")) {
    setCookie("waterdrop_ch","ShareASale");
    delCookie("ref", true);
}
if (url.includes("&awc")) {
    setCookie("waterdrop_ch","Awin");
    delCookie("ref", true);
}

function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

function setCookie(name,value)
{
    var Days = 45;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path=/;";
}

function getCookie(name)
{
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
 
    if(arr=document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

function delCookie(name, extra=false)
{
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval=getCookie(name);
    if(cval!=null) {
        if (extra == true) {
            document.cookie= name + "=;path=/;domain=.waterdropfilter.com;max-age=0";
            document.cookie= name + "=;path=/;max-age=0";
            document.cookie= name + "=;path=/;domain=.www.waterdropfilter.com;max-age=0";
        } else {
            document.cookie= name + "=;path=/;";
        }
    }
}